import { c as _c } from "react/compiler-runtime";
import type { UiLabelsOverrides } from "@dc/ui/components/UiLabels";
import { useTranslations } from "next-intl";
export function useTranslatedUiLabels() {
  const $ = _c(160);
  const t = useTranslations("ui");
  let t0;
  if ($[0] !== t) {
    t0 = t("banner.dismiss");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      dismiss: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  let t3;
  if ($[4] !== t) {
    t2 = count => t("bulk_actions.selected", {
      count
    });
    t3 = t("bulk_actions.actions");
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("bulk_actions.submenu");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      selected: t2,
      actions: t3,
      submenu: t4
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("citations.sources");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = {
      sources: t6
    };
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("email_input.label");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("email_input.placeholder");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("email_input.suggestions");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("email_input.loading");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("email_input.invalid");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t8 || $[31] !== t9) {
    t13 = {
      label: t8,
      placeholder: t9,
      suggestions: t10,
      loading: t11,
      invalid: t12
    };
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t8;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  let t15;
  if ($[33] !== t) {
    t14 = count_0 => t("move_destination.title", {
      count: count_0
    });
    t15 = t("move_destination.search");
    $[33] = t;
    $[34] = t14;
    $[35] = t15;
  } else {
    t14 = $[34];
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("move_destination.new_project");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("move_destination.new_folder");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t) {
    t18 = t("move_destination.cancel");
    $[40] = t;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("move_destination.move");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  let t21;
  if ($[44] !== t) {
    t20 = count_1 => t("move_destination.move_here", {
      count: count_1
    });
    t21 = t("move_destination.no_projects");
    $[44] = t;
    $[45] = t20;
    $[46] = t21;
  } else {
    t20 = $[45];
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t14 || $[48] !== t15 || $[49] !== t16 || $[50] !== t17 || $[51] !== t18 || $[52] !== t19 || $[53] !== t20 || $[54] !== t21) {
    t22 = {
      title: t14,
      search: t15,
      newProject: t16,
      newFolder: t17,
      cancel: t18,
      move: t19,
      moveHere: t20,
      noProjects: t21
    };
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
    $[52] = t19;
    $[53] = t20;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t) {
    t23 = t("multi_select.show_options");
    $[56] = t;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t) {
    t24 = t("multi_select.hide_options");
    $[58] = t;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t) {
    t25 = t("multi_select.loading");
    $[60] = t;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t23 || $[63] !== t24 || $[64] !== t25) {
    t26 = {
      showOptions: t23,
      hideOptions: t24,
      loading: t25
    };
    $[62] = t23;
    $[63] = t24;
    $[64] = t25;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  let t27;
  if ($[66] !== t) {
    t27 = t("scope_navigation.root");
    $[66] = t;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t) {
    t28 = t("scope_navigation.current");
    $[68] = t;
    $[69] = t28;
  } else {
    t28 = $[69];
  }
  let t29;
  if ($[70] !== t) {
    t29 = t("scope_navigation.no_items");
    $[70] = t;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  let t31;
  let t32;
  if ($[72] !== t) {
    t30 = name => t("scope_navigation.navigate_to", {
      name
    });
    t31 = name_0 => t("scope_navigation.select", {
      name: name_0
    });
    t32 = name_1 => t("scope_navigation.selected", {
      name: name_1
    });
    $[72] = t;
    $[73] = t30;
    $[74] = t31;
    $[75] = t32;
  } else {
    t30 = $[73];
    t31 = $[74];
    t32 = $[75];
  }
  let t33;
  if ($[76] !== t27 || $[77] !== t28 || $[78] !== t29 || $[79] !== t30 || $[80] !== t31 || $[81] !== t32) {
    t33 = {
      root: t27,
      current: t28,
      noItems: t29,
      navigateTo: t30,
      select: t31,
      selected: t32
    };
    $[76] = t27;
    $[77] = t28;
    $[78] = t29;
    $[79] = t30;
    $[80] = t31;
    $[81] = t32;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  let t34;
  if ($[83] !== t) {
    t34 = t("scope_selector.title");
    $[83] = t;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  let t35;
  if ($[85] !== t) {
    t35 = t("scope_selector.search");
    $[85] = t;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t) {
    t36 = t("scope_selector.selected");
    $[87] = t;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] !== t) {
    t37 = t("scope_selector.show_more");
    $[89] = t;
    $[90] = t37;
  } else {
    t37 = $[90];
  }
  let t38;
  if ($[91] !== t) {
    t38 = t("scope_selector.show_less");
    $[91] = t;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] !== t) {
    t39 = t("scope_selector.clear_selection");
    $[93] = t;
    $[94] = t39;
  } else {
    t39 = $[94];
  }
  let t40;
  if ($[95] !== t) {
    t40 = t("scope_selector.cancel");
    $[95] = t;
    $[96] = t40;
  } else {
    t40 = $[96];
  }
  let t41;
  if ($[97] !== t) {
    t41 = t("scope_selector.apply");
    $[97] = t;
    $[98] = t41;
  } else {
    t41 = $[98];
  }
  let t42;
  if ($[99] !== t) {
    t42 = t("scope_selector.no_projects");
    $[99] = t;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== t) {
    t43 = t("scope_selector.no_files_or_folders");
    $[101] = t;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  let t44;
  if ($[103] !== t34 || $[104] !== t35 || $[105] !== t36 || $[106] !== t37 || $[107] !== t38 || $[108] !== t39 || $[109] !== t40 || $[110] !== t41 || $[111] !== t42 || $[112] !== t43) {
    t44 = {
      title: t34,
      search: t35,
      selected: t36,
      showMore: t37,
      showLess: t38,
      clearSelection: t39,
      cancel: t40,
      apply: t41,
      noProjects: t42,
      noFilesOrFolders: t43
    };
    $[103] = t34;
    $[104] = t35;
    $[105] = t36;
    $[106] = t37;
    $[107] = t38;
    $[108] = t39;
    $[109] = t40;
    $[110] = t41;
    $[111] = t42;
    $[112] = t43;
    $[113] = t44;
  } else {
    t44 = $[113];
  }
  let t45;
  if ($[114] !== t) {
    t45 = t("search.tooltip");
    $[114] = t;
    $[115] = t45;
  } else {
    t45 = $[115];
  }
  let t46;
  if ($[116] !== t) {
    t46 = t("search.open");
    $[116] = t;
    $[117] = t46;
  } else {
    t46 = $[117];
  }
  let t47;
  if ($[118] !== t45 || $[119] !== t46) {
    t47 = {
      tooltip: t45,
      open: t46
    };
    $[118] = t45;
    $[119] = t46;
    $[120] = t47;
  } else {
    t47 = $[120];
  }
  let t48;
  let t49;
  if ($[121] !== t) {
    t48 = page => t("side_panel_pagination.page_with_number", {
      page
    });
    t49 = t("side_panel_pagination.previous");
    $[121] = t;
    $[122] = t48;
    $[123] = t49;
  } else {
    t48 = $[122];
    t49 = $[123];
  }
  let t50;
  if ($[124] !== t) {
    t50 = t("side_panel_pagination.previous_page");
    $[124] = t;
    $[125] = t50;
  } else {
    t50 = $[125];
  }
  let t51;
  if ($[126] !== t) {
    t51 = t("side_panel_pagination.next");
    $[126] = t;
    $[127] = t51;
  } else {
    t51 = $[127];
  }
  let t52;
  if ($[128] !== t) {
    t52 = t("side_panel_pagination.next_page");
    $[128] = t;
    $[129] = t52;
  } else {
    t52 = $[129];
  }
  let t53;
  if ($[130] !== t48 || $[131] !== t49 || $[132] !== t50 || $[133] !== t51 || $[134] !== t52) {
    t53 = {
      pageWithNumber: t48,
      previous: t49,
      previousPage: t50,
      next: t51,
      nextPage: t52
    };
    $[130] = t48;
    $[131] = t49;
    $[132] = t50;
    $[133] = t51;
    $[134] = t52;
    $[135] = t53;
  } else {
    t53 = $[135];
  }
  let t54;
  if ($[136] !== t) {
    t54 = t("table.loading");
    $[136] = t;
    $[137] = t54;
  } else {
    t54 = $[137];
  }
  let t55;
  if ($[138] !== t54) {
    t55 = {
      loading: t54
    };
    $[138] = t54;
    $[139] = t55;
  } else {
    t55 = $[139];
  }
  let t56;
  if ($[140] !== t) {
    t56 = t("value_filter.min");
    $[140] = t;
    $[141] = t56;
  } else {
    t56 = $[141];
  }
  let t57;
  if ($[142] !== t) {
    t57 = t("value_filter.max");
    $[142] = t;
    $[143] = t57;
  } else {
    t57 = $[143];
  }
  let t58;
  if ($[144] !== t56 || $[145] !== t57) {
    t58 = {
      min: t56,
      max: t57
    };
    $[144] = t56;
    $[145] = t57;
    $[146] = t58;
  } else {
    t58 = $[146];
  }
  let t59;
  if ($[147] !== t1 || $[148] !== t13 || $[149] !== t22 || $[150] !== t26 || $[151] !== t33 || $[152] !== t44 || $[153] !== t47 || $[154] !== t5 || $[155] !== t53 || $[156] !== t55 || $[157] !== t58 || $[158] !== t7) {
    t59 = {
      banner: t1,
      bulkActions: t5,
      citations: t7,
      emailInput: t13,
      moveDestination: t22,
      multiSelect: t26,
      scopeNavigation: t33,
      scopeSelector: t44,
      search: t47,
      sidePanelPagination: t53,
      table: t55,
      valueFilter: t58
    };
    $[147] = t1;
    $[148] = t13;
    $[149] = t22;
    $[150] = t26;
    $[151] = t33;
    $[152] = t44;
    $[153] = t47;
    $[154] = t5;
    $[155] = t53;
    $[156] = t55;
    $[157] = t58;
    $[158] = t7;
    $[159] = t59;
  } else {
    t59 = $[159];
  }
  return t59;
}